export default function HelmIcon({ className = "w-6 h-6" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Outer ring */}
      <circle cx="12" cy="12" r="9" />
      {/* Inner ring */}
      <circle cx="12" cy="12" r="4" />
      {/* 8 spokes with handles */}
      <line x1="12" y1="3" x2="12" y2="8" />
      <line x1="12" y1="16" x2="12" y2="21" />
      <line x1="3" y1="12" x2="8" y2="12" />
      <line x1="16" y1="12" x2="21" y2="12" />
      <line x1="5.64" y1="5.64" x2="9.17" y2="9.17" />
      <line x1="14.83" y1="14.83" x2="18.36" y2="18.36" />
      <line x1="5.64" y1="18.36" x2="9.17" y2="14.83" />
      <line x1="14.83" y1="9.17" x2="18.36" y2="5.64" />
      {/* Handle knobs at the end of spokes */}
      <circle cx="12" cy="2" r="1" fill="currentColor" stroke="none" />
      <circle cx="12" cy="22" r="1" fill="currentColor" stroke="none" />
      <circle cx="2" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="22" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="4.93" cy="4.93" r="1" fill="currentColor" stroke="none" />
      <circle cx="19.07" cy="19.07" r="1" fill="currentColor" stroke="none" />
      <circle cx="4.93" cy="19.07" r="1" fill="currentColor" stroke="none" />
      <circle cx="19.07" cy="4.93" r="1" fill="currentColor" stroke="none" />
    </svg>
  )
}
